<template>
    <div class="other-field ">
        <div class="display-flex">
            <div class="label-width">
                <div class="label-icon"><i class="fas fa-comments"></i></div>
                <div class="label-text">Comments</div>
            </div>
            <div class="label-field comments">
                <div class="box" v-for="comment in comments">
                    <article class="media">
                        <div class="media-content">
                            <div class="content">
                                <p>
                                    <strong>{{ comment.user.name }}</strong> <small>@</small> <small>{{ comment.created_at }}</small>
                                    <br>
                                    {{ comment.body }}
                                </p>
                            </div>
                        </div>
                    </article>
                </div>
                <div class="video-files" v-if="comments.length < 1">
                    No Comments
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import commentsApi from './../../../api/apiComments.js'
    export default {
        props: ['car'],
        data () {
            return {
                comments: [],
                query: {
                    lot_id: this.car.lot_id
                },
            }
        },
        created () {
            commentsApi
                .getThreatRequest(this.query)
                .then((response) => {
                    if (response.data.comments){
                        this.comments = response.data.comments
                    }
                })
                .catch(error => console.log(error))
        },

    }
</script>

<style scoped>
    .link:hover {
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cars/Car/CommentsBox.vue